module.exports = __webpack_public_path__ + "img/Pic_JFPH1.bd64fef6.png";